import { action, ActionType } from "typesafe-actions";
import { IError } from "../../../redux/actions/errorHandlingAction";
import { SearchResults } from "../../../types/search/search-results.interface";
import { ProductSubcategory } from "../types/product-subcategory.interface";

export enum ProductSearchSharedActions {
  SearchCategory = "ProductSearchShared/SearchClass",
  SearchCategorySuccess = "ProductSearchShared/SearchClassSuccess",
  SearchCategoryFailure = "ProductSearchFailure/SearchClassFailure",

  SearchSubcategory = "ProductSearchShared/SearchSubClass",
  SearchSubcategorySuccess = "ProductSearchShared/SearchSubClassSuccess",
  SearchSubcategoryFailure = "ProductSearchFailure/SearchSubClassFailure",

  ClearCategoryResults = "ProductSearchFailure/ClearClassResults",
  ClearSubcategoryResults = "ProductSearchFailure/ClearSubClassResults",
}

export const searchCategory = (searchText: string) =>
  action(ProductSearchSharedActions.SearchCategory, searchText);

export const searchCategorySuccess = (results: SearchResults<ProductSubcategory>) =>
  action(ProductSearchSharedActions.SearchCategorySuccess, results);

export const searchCategoryFailure = (error: IError) =>
  action(ProductSearchSharedActions.SearchCategoryFailure, error);

export const searchSubcategory = (searchText: string) =>
  action(ProductSearchSharedActions.SearchSubcategory, searchText);

export const searchSubcategorySuccess = (results: SearchResults<ProductSubcategory>) =>
  action(ProductSearchSharedActions.SearchSubcategorySuccess, results);

export const searchSubcategoryFailure = (error: IError) =>
  action(ProductSearchSharedActions.SearchSubcategoryFailure, error);

export const clearCategoryResults = () => action(ProductSearchSharedActions.ClearCategoryResults);

export const clearSubcategoryResults = () =>
  action(ProductSearchSharedActions.ClearSubcategoryResults);

const actionCreators = {
  searchCategory,
  searchCategorySuccess,
  searchCategoryFailure,

  searchSubcategory,
  searchSubcategorySuccess,
  searchSubcategoryFailure,

  clearCategoryResults,
  clearSubcategoryResults,
};

export type ProductSearchSharedActionType = ActionType<typeof actionCreators>;
